import axiosInstance from ".";


export const createSubCategory = async ({ parentCategoryId, formData }) => {
    const response = await axiosInstance.post(`/categories/${parentCategoryId}/subcategory`, formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}

export const getAllSubCategories = async ({ parentCategoryId }) => {
    const response = await axiosInstance.get(`/categories/${parentCategoryId}/subcategory/`)
    return response;
}

export const getSubCategoryById = async ({ parentCategoryId, subcategoryId }) => {
    const response = await axiosInstance.get(`/categories/${parentCategoryId}/subcategory/${subcategoryId}`)
    return response;
}


export const deleteSubCategory = async ({ parentCategoryId, subcategoryId }) => {
    const response = await axiosInstance.delete(`/categories/${parentCategoryId}/subcategory/${subcategoryId}`)
    return response;
}

export const updateSubCategory = async ({ formData, parentCategoryId, subcategoryId, }) => {
    const response = await axiosInstance.put(`/categories/${parentCategoryId}/subcategory/${subcategoryId}`, formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}
export const getAllProductsUnderSubCategory = async ({ subcategoryId }) => {
    const response = await axiosInstance.get(`/categories/subcategory/${subcategoryId}`)
    return response;
}
export const getSKUUnderSubCategory = async ({ parentCategoryId, subcategoryId }) => {
    const response = await axiosInstance.get(`/categories/${parentCategoryId}/subcategory/${subcategoryId}/parameters`)
    return response;
}